export const INTEGRATIONS_API_BASE =
  'https://266s5nz9rc.execute-api.us-west-2.amazonaws.com/prod';
